// extracted by mini-css-extract-plugin
export default {"recos":"Y6-z","productCardOverride":"Z6-z","rowHasBadge":"_6-z"};